import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class Languages extends React.Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.code}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Code']}
          rows={master.allLanguages.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query LanguagesAdminQuery {
    master {
      ...Languages_master
    }
  }
`;

export default enhancer(Languages, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Languages, {
        master: graphql`
          fragment Languages_master on Master {
            allLanguages(first: 50) {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Languages.js